import { Box } from "./Box";
import { Div } from "../Div";
import { Img } from "../Img";
import { CFlexContainer } from "../Container/CFlexContainer";
import { TextField } from "../TextField";
import { Section } from "./TBox/Section";
import { toMap } from "../../../../HA";

export class TextBox extends Box {
    protected createByType(data: Map<any, any>) {
        switch (data.get("t")) {
            case "s":
                return new Section({d: data.get("d")});
            case "t1":
                const tag = new Div(data.get("d"));
                tag.addClass("t1");
                return tag;
            case "img":
                return new Img(data.get("d"));
            default:
                return null;
        }
    }

    protected createSelf() {
        super.createSelf();
        this.addClass("tbox");
        const c = new CFlexContainer();
        let tdata = this.get("tdata");
        if (!tdata) {
            tdata = this.getData();
            tdata.forEach((item: any) => {
                c.appendChild(new TextField(item));
            });
        } else {
            tdata.forEach((item: any) => {
                const child = this.createByType(toMap(item) as Map<any, any>);
                if (child) { c.appendChild(child); }
            });
        }
        this.appendChild(c);
    }
}
